import React from 'react';
import { QueryKey } from 'react-query';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterOperationStateValue,
  UniversalFilterOperationStateModes,
  UniversalFilterOperationStateOnChange
} from './UniversalFilterOperationState.types';

import { useUniversalFilterOperationState } from './hooks/useUniversalFilterOperationState';

import { OperationsStatesMultiSelect } from '../../../../../main/operations/helpers/OperationsStatesMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterOperationStateProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterOperationStateValue;
  i18nName: I18nText;
  autoFocus?: boolean;
  onChange: UniversalFilterOperationStateOnChange;
}

function UniversalFilterOperationState({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  autoFocus,
  onChange
}: UniversalFilterOperationStateProps) {
  const { modeOptions, filterState, handleModeChange, handleStatusesChange } =
    useUniversalFilterOperationState({
      filterStateCacheKey,
      filterValue,
      onChange
    });

  return (
    <UniversalFilterTemplate<UniversalFilterOperationStateModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      <OperationsStatesMultiSelect
        key={filterState.mode}
        value={filterState.states || []}
        autoFocus={autoFocus}
        onChange={handleStatusesChange}
      />
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterOperationState;
